type FullScreenLoaderProps = {
  text?: string;
  color?: "orange" | "blue";
  size?: "sm" | "lg";
};

const SPINNER_COLOR = {
  orange: "border-t-[#ff7751]",
  blue: "border-t-blue",
};

const SPINNER_SIZE = {
  sm: "h-12 w-12",
  lg: "h-16 w-16",
};

const TEXT_OFFSET = {
  sm: "top-[calc(50%+40px)]",
  lg: "top-[calc(50%+48px)]",
};

const FullScreenLoader = ({
  text,
  color = "orange",
  size = "sm",
}: FullScreenLoaderProps) => {
  return (
    <div className="fixed inset-0 z-[9999] bg-white">
      <div
        className={`absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 animate-spin rounded-full border-4 border-gray-3 ${SPINNER_SIZE[size]} ${SPINNER_COLOR[color]}`}
      />
      {text && (
        <p
          className={`absolute left-1/2 ${TEXT_OFFSET[size]} -translate-x-1/2 whitespace-nowrap text-sm text-dark-4`}
        >
          {text}
        </p>
      )}
    </div>
  );
};

export default FullScreenLoader;
